import axios from 'axios';
import vopayApi from '@/services/api.config';
import {
  SubAccount,
  SubAccountsRequest,
  CreateSubAccountRequest,
  AccountTransferFromRequest,
  AccountTransferToRequest,
} from 'vopay';
import { useState } from 'react';

const { api } = vopayApi;

export default function useSubAccounts() {
  const source = axios.CancelToken.source();
  const [subAccounts, setSubAccounts] = useState<SubAccount[]>([]);

  async function fetchSubAccounts(params: SubAccountsRequest) {
    try {
      const res = await api.fetchSubAccounts(params, source);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      setSubAccounts(Object.values(res.Subaccounts));
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async function createSubAccount(params: CreateSubAccountRequest) {
    try {
      const res = await api.postCreateSubAccount(params, source);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async function transferAccountFrom(params: AccountTransferFromRequest) {
    try {
      const res = await api.postAccountTransferFrom(params, source);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async function transferAccountTo(params: AccountTransferToRequest) {
    try {
      const res = await api.postAccountTransferTo(params, source);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  return {
    subAccounts,
    fetchSubAccounts,
    createSubAccount,
    transferAccountFrom,
    transferAccountTo,
  };
}
